// Negative-on-hand was a glow with no landing. This row is that landing.
import type { ActivityDockStatusReasonCode } from "@/components/activity/fireflyStatusReason";

export function NegativeOnHandAttentionRow(props: {
  count: number;
  onOpenInventory?: () => void;
}) {
  const n = props.count;
  const copy =
    n === 1
      ? "A material is below zero. Fix it in Inventory."
      : `${n} materials are below zero. Fix them in Inventory.`;
  return (
    <section
      aria-label="Materials below zero"
      className="mt-3 rounded-lg border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/60 dark:bg-amber-950/30"
    >
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-amber-900 dark:text-amber-200">
        Inventory
      </h3>
      <p className="mt-1 text-[12px] text-amber-900 dark:text-amber-200">{copy}</p>
      {props.onOpenInventory ? (
        <button
          type="button"
          onClick={props.onOpenInventory}
          className="mt-2 rounded-lg bg-amber-700 px-2.5 py-1.5 text-[11px] font-semibold text-white hover:bg-amber-800 dark:bg-amber-600"
        >
          Open Inventory
        </button>
      ) : null}
    </section>
  );
}

export const NEGATIVE_ON_HAND_REASON: ActivityDockStatusReasonCode = "negative_on_hand";
